import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { getMessaging, getToken } from 'firebase/messaging';

import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class FcmService {

  constructor(
    private afMessaging: AngularFireMessaging,
    private alertService: AlertService) {
  }

  requestPermission = async () => {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        throw new Error('Permission not granted');
      }

      const registration = await navigator.serviceWorker.ready;
      const messaging = getMessaging();

      const token = await getToken(messaging, {
        vapidKey: environment.firebase.vapidKey,
        serviceWorkerRegistration: registration,
      });
      return token || '';
    
  }

  receiveMessages = () => {
    this.afMessaging.onMessage((message: any) => {
      if (message.notification) {
        const { body, title, click_action, icon, tag } = message.notification;

        let options: any = {
          body,
          tag,
          icon,
        };
        if (message.data && message.data.actions) {
          let actions = JSON.parse(message.data.actions);
          actions = actions.map(
            ({ action, title }) => ({
              action,
              title
            })
          );
          options = { ...options, actions };
        }
        this.alertService.openSnackBar(
          `${title}: ${body}`,
          "warn",
          
        )
        Notification.requestPermission()
          .then((result) => {
            if (result === 'denied') {
              return;
            }
            if (result === 'default') {
              return;
            }
            navigator.serviceWorker.ready
              .then((registration) => {
                registration
                  .showNotification(title, options);
              })
              .catch(er => {
                console.log(er);
              });
          });
      }
    });
  }

}
